import { useState } from 'react'
import Button from '@material-ui/core/Button'
import LibraryAddIcon from '@material-ui/icons/LibraryAdd'
import { useTranslation } from 'react-i18next'

import AddDialog from './AddDialog'

export default function AddDialogButton({ isOffline, isLoading }) {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const handleClickOpen = () => setIsDialogOpen(true)
  const handleClose = () => setIsDialogOpen(false)

  return (
    <>
      <Button
        className='header-action'
        disabled={isOffline || isLoading}
        onClick={handleClickOpen}
        variant='outlined'
        size='small'
        startIcon={<LibraryAddIcon />}
      >
        <span className='action-label'>{t('AddFromLink')}</span>
      </Button>

      {isDialogOpen && <AddDialog handleClose={handleClose} />}
    </>
  )
}
